const messages = {
  header: 'Blog',
}

export default messages
